function fadein () {

    function link (scope, elem, attrs) {
        

        function onWindowScroll(event) {
            var scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop; // For ie 11
            if (elem[0].offsetTop - window.innerHeight / 2 < scrollTop) {
                console.log('fadein');
                elem[0].classList.add('visible');
            }
        }

        window.addEventListener('scroll', onWindowScroll);
        onWindowScroll();
        
    }

    return {
        restrict: 'A',
        link: link
    };
}